"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liMul = liMul;
/**
 * 
 * @param priceEach Line-item price each (base currency, not cents)
 * @param qty Quantity
 * @param priceEachDecimalPrecision The decimal precision of priceEach
 * @param qtyDecimalPrecision The decimal precision of qty
 * @returns The total price in cents
 */
function liMul(priceEach, qty, priceEachDecimalPrecision = 2, qtyDecimalPrecision = 0) {
  return Math.round(Math.round(priceEach * 10 ** priceEachDecimalPrecision) * Math.round(qty * 10 ** qtyDecimalPrecision) / 10 ** (priceEachDecimalPrecision + qtyDecimalPrecision - 2));
}